import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { supportedLngsObj } from "../helpers/utils";

const SeoHead = ({ title, description, titleHi, descriptionHi, keywords }) => {
  const { pathname } = useLocation();
  const baseUrl = "https://www.nuvoco.com";

  const langs = {
    en: "",
    hi: "/hindi",
    gu: "/gujarati",
  };
  alert(descriptionHi);
  const canonical = `${baseUrl}${pathname}`;
  const hreflangs = Object.entries(langs).map(([code, prefix]) => ({
    hrefLang: code === "en" ? "en" : code,
    href: `${baseUrl}${prefix}${pathname}`,
  }));

  return (
    <Helmet>
      <title>{title || "Vadraj Cement Ltd."}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {hreflangs.map((l) => (
        <link
          key={l.hrefLang}
          rel="alternate"
          hrefLang={l.hrefLang}
          href={l.href}
        />
      ))}
    </Helmet>
  );
};

export default SeoHead;
